export const SHOW_SPLASHSCREEN = 'SHOW_SPLASHSCREEN';
export const SHOW_LOADING = 'SHOW_LOADING';
export const SHOW_MODAL_CART_EXPIRED = 'SHOW_MODAL_CART_EXPIRED';
export const SHOW_MODAL_CART_TIMER = 'SHOW_MODAL_CART_TIMER';
export const SHOW_MODAL_CART_RESET = 'SHOW_MODAL_CART_RESET';
export const SHOW_MODAL_ERRORS = 'SHOW_MODAL_ERRORS';
